// extracted by mini-css-extract-plugin
export default {"quickLinksOuter":"QuickLinksContainer_quickLinksOuter__LUWwF","quickLinksInner":"QuickLinksContainer_quickLinksInner__MWGzh"};